/* unplugin-vue-components disabled */import { render } from "./ImageTop.vue?vue&type=template&id=4636f3ac&scoped=true"
import script from "./ImageTop.vue?vue&type=script&lang=js"
export * from "./ImageTop.vue?vue&type=script&lang=js"

import "./ImageTop.vue?vue&type=style&index=0&id=4636f3ac&scoped=true&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4636f3ac"]])

export default __exports__